import PublishedLists from '@/shared/publish/MyPublications/PublishedLists/'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/MyPublications/PublishedLists/')(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  return <PublishedLists />
}
